export const getMenuEntityKey = (itemOption: { _key: string } | { _id: string } | null): string => {
  if (!itemOption) {
    return '';
  }
  if ('_id' in itemOption) {
    return itemOption._id;
  }
  return itemOption._key ?? '';
};
